import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const EmploymentStatusDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Employment Status"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Employment Status">
                {getFieldDecorator('employmentStatus', {
                 initialValue: data.employmentStatus,
                  rules: [{ required: true, message: 'Please input the Employment Status!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default EmploymentStatusDialogForm;
